import ApiService from './api_service'

export default {
  async preview(id: number | string): Promise<{ preview_url: string }> {
    const response = await ApiService.get(`/product-variants/${id}/preview`)
    return response.data
  }
}
